"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMerchantProfileResponseSchema = exports.updateMerchantProfileBodySchema = exports.getMerchantProfileResponseSchema = exports.updateMerchantProfileParamsSchema = exports.getMerchantProfileParamsSchema = exports.MerchantEntitySchema = void 0;
const zod_1 = require("zod");
const api_schemas_1 = require("../base/api.schemas");
const timestamp_schemas_1 = require("../base/timestamp.schemas");
// ============================================
// INTERNAL SCHEMAS (Entity)
// ============================================
// Merchant base schema matching database merchants table
const _MerchantBaseSchema = zod_1.z.object({
    merchant_id: zod_1.z.number().int().positive(),
    merchant_name: zod_1.z.string().max(200),
    merchant_description: zod_1.z.string().nullable(),
    logo_url: zod_1.z.string().url().max(500).nullable(),
    slug: zod_1.z.string().min(3).max(50).regex(/^[a-z0-9-]+$/).nullable(),
    is_active: zod_1.z.boolean().default(true),
    created_at: timestamp_schemas_1.timestampIsoSchema,
    updated_at: timestamp_schemas_1.timestampIsoSchema,
});
// ============================================
// ENTITY SCHEMAS (Export Aliases)
// ============================================
exports.MerchantEntitySchema = _MerchantBaseSchema;
// ============================================
// MERCHANT PROFILE API SCHEMAS
// ============================================
// Common path params for all merchant endpoints
// CRITICAL: merchantId is INTEGER, not UUID (only user.id is UUID)
const _MerchantParamsSchema = zod_1.z.object({
    merchantId: zod_1.z.coerce.number().int().positive(),
});
// GET /merchants/:merchantId - Params
exports.getMerchantProfileParamsSchema = _MerchantParamsSchema;
// PATCH /merchants/:merchantId - Params
exports.updateMerchantProfileParamsSchema = _MerchantParamsSchema;
// GET /merchants/:merchantId - Response (FR7, FR175-177)
// Returns full merchant entity
exports.getMerchantProfileResponseSchema = (0, api_schemas_1.dataResponseSchema)(_MerchantBaseSchema);
// PATCH /merchants/:merchantId - Body (FR7, FR175-177)
exports.updateMerchantProfileBodySchema = zod_1.z.object({
    merchant_name: zod_1.z.string().max(200).optional(),
    merchant_description: zod_1.z.string().optional(),
    logo_url: zod_1.z.string().url().nullable().optional(), // URL after upload
});
// PATCH /merchants/:merchantId - Response
// Returns subset of merchant entity after update
exports.updateMerchantProfileResponseSchema = (0, api_schemas_1.dataResponseSchema)(_MerchantBaseSchema.pick({
    merchant_id: true,
    merchant_name: true,
    merchant_description: true,
    logo_url: true,
    updated_at: true,
}));
